import { FC } from "react";
import styled from "styled-components";
import { LayoutConst } from "core";
import { ZharKnigaBadgeSvg } from './ZharKnigaBadgeSvg';

const BadgeContainer = styled.div<{ isGridBadge?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  
  ${({ isGridBadge }) => isGridBadge ? `
    width: 80px;
    
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 60px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 56px;
    }
    @media (max-width: ${LayoutConst.screen.sm}px) {
      width: 42px;
    }
  ` : `
    width: 160px;
    
    @media (max-width: ${LayoutConst.screen.mac13}px) {
      width: 120px;
    }
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 20vw;
    }
    @media (max-width: ${LayoutConst.screen.sm}px) {
      width: 21vw;
    }
    @media (max-width: ${LayoutConst.screen.xsm}px) {
      width: 28vw;
    }
  `}
  
  img, svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

type ZharKnigaBadgeProps = {
  isGridBadge?: boolean;
  onhoverPlate?: boolean;
};

export const ZharKnigaBadge: FC<ZharKnigaBadgeProps> = ({ isGridBadge, onhoverPlate }) => {
  return (
    <BadgeContainer 
      isGridBadge={isGridBadge}
      style={{
        opacity: onhoverPlate ? 0 : 1,
        visibility: onhoverPlate ? 'hidden' : 'visible',
        transition: 'opacity 0.3s ease, visibility 0.3s ease'
      }}
    >
      <ZharKnigaBadgeSvg />
    </BadgeContainer>
  );
};

import { FC } from "react";
import styled from "styled-components";
import { LayoutConst } from "core";
import { ZharKnigaBadgeSvg } from './ZharKnigaBadgeSvg';

const BadgeContainer = styled.div<{ isGridBadge?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  
  ${({ isGridBadge }) => isGridBadge ? `
    width: 80px;
    
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 60px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 56px;
    }
    @media (max-width: ${LayoutConst.screen.sm}px) {
      width: 42px;
    }
  ` : `
    width: 160px;
    
    @media (max-width: ${LayoutConst.screen.mac13}px) {
      width: 120px;
    }
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 20vw;
    }
    @media (max-width: ${LayoutConst.screen.sm}px) {
      width: 21vw;
    }
    @media (max-width: ${LayoutConst.screen.xsm}px) {
      width: 28vw;
    }
  `}
  
  img, svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

type ZharKnigaBadgeProps = {
  isGridBadge?: boolean;
  onhoverPlate?: boolean;
};

export const ZharKnigaBadge: FC<ZharKnigaBadgeProps> = ({ isGridBadge, onhoverPlate }) => {
  return (
    <BadgeContainer 
      isGridBadge={isGridBadge}
      style={{
        opacity: onhoverPlate ? 0 : 1,
        visibility: onhoverPlate ? 'hidden' : 'visible',
        transition: 'opacity 0.3s ease, visibility 0.3s ease'
      }}
    >
      <ZharKnigaBadgeSvg />
    </BadgeContainer>
  );
};

